export function errorToString(error) {
    if (error instanceof Error) {
        return error.stack ? error.stack : error.message;
    }
    else if (typeof error === 'string') {
        return error;
    }
    else {
        return JSON.stringify(error);
    }
}
export function hasCode(error) {
    return error !== null && typeof error === 'object' && 'code' in (error !== null && error !== void 0 ? error : {});
}
export function toError(error) {
    if (error instanceof Error)
        return error;
    if (typeof error === 'string')
        return new Error(error);
    return new Error(JSON.stringify(error));
}
// https://firebase.google.com/docs/reference/node/firebase.functions#functionserrorcode
// https://github.com/grpc/grpc/blob/master/doc/statuscodes.md
export const grpcCodes = [
    'cancelled',
    'unknown',
    'invalidArgument',
    'deadlineExceeded',
    'notFound',
    'alreadyExists',
    'permissionDenied',
    'resourceExhausted',
    'failedPrecondition',
    'aborted',
    'outOfRange',
    'unimplemented',
    'unavailable',
    'dataLoss',
    'unauthenticated',
    'internal',
];
export class GrpcError extends Error {
    constructor(code, message) {
        super(message);
        this.code = code;
    }
}
export class ErrorWithCode extends Error {
    constructor(code, message) {
        super(`${code}: ${message}`);
        this.code = code;
    }
}
